import {
  SUPER_PROJECT_NAME,
  PAYMENT_SUBSYSTEM_V3_VARIANT,
} from 'src/constants';
import { Button } from 'src/v2/commonComponents/Button';
import { AppRoutes } from 'src/types';
import styles from './OnDemandCreditPack.module.scss';
import { useFeatureFlagVariantKey } from 'posthog-js/react';

export const OnDemandCreditPack = () => {
  const paymentSubsystemVariant = useFeatureFlagVariantKey('payment-subsystem');
  const isShowNewPaymentModalV3 =
    paymentSubsystemVariant === PAYMENT_SUBSYSTEM_V3_VARIANT;
  return (
    <div className={styles.root}>
      <div
        className={
          isShowNewPaymentModalV3 ? styles.smallerContainer : styles.container
        }
      >
        <div className={styles.header}>
          <span className={styles.title}>
            On-demand {SUPER_PROJECT_NAME} Credit Pack
          </span>
          <span className={styles.subTitle}>
            Never run out of {SUPER_PROJECT_NAME} tasks. Buy More, Get More: Up
            to 10% Bonus Credits.
          </span>
        </div>
        <Button as="link" to={AppRoutes.ADD_ON} color="primary">
          Enable On-Demand
        </Button>
      </div>
    </div>
  );
};
